import { useIsMutating } from "@tanstack/react-query";
import { applyUpdate, useAppUpdateStore } from "../../../shared/lib/app-version";

export function useUpdateBanner() {
  const updateAvailable = useAppUpdateStore((s) => s.updateAvailable);
  // Same gate as the automatic reloads: a reload mid-request could abort a save the user believes landed.
  const isSaving = useIsMutating() > 0;
  return { updateAvailable, isSaving, reload: applyUpdate };
}
